import { faker } from '@faker-js/faker';
import { HttpResponse, delay, http } from 'msw';

faker.seed(1);

export const getGetGeneralReportsMock = (page: number) => {
  return {
    next: page <= 2 ? `/api/js/general_reports?page=${page + 1}` : undefined,
    prev: page > 1 ? `/api/js/general_reports?page=${page - 1}` : undefined,
    general_reports: Array.from({ length: 100 }, () => {
      return {
        number: 'AP-' + faker.string.uuid(),
        title: 'AP-' + faker.string.uuid(),
      };
    }),
  };
};

export const handlers = [
  http.get('*/api/js/general_reports', async ({ request }) => {
    await delay(1000);
    const url = new URL(request.url);
    const status = url.searchParams.get('status');
    const page = url.searchParams.has('page')
      ? parseInt(url.searchParams.get('page') ?? '1')
      : 1;
    if (status !== 'approved') {
      return new HttpResponse(
        JSON.stringify({
          code: 'not_found',
          messages: ['not found'],
        }),
        {
          status: 400,
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
    }

    return new HttpResponse(JSON.stringify(getGetGeneralReportsMock(page)), {
      status: 200,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }),
];
